import ReactDOM from 'react-dom';

export const withButtonPortal = (WrappedComponent, slotNr) => {
    const statusBarButtonSlot = document.querySelector('.status-btn-' + slotNr);
    return ReactDOM.createPortal(WrappedComponent, statusBarButtonSlot);
}

export const withSliderPortal = (WrappedComponent) => {
    const statusSliderSlot = document.querySelector('.status-slider');
    return ReactDOM.createPortal(WrappedComponent, statusSliderSlot);
}